// Interfaces
export interface IExternalLinkWidgetModel {
    description: string;
    url: string;
    isLoginModal: boolean;
    hasUrl: boolean;
}

export interface IContentBlockWidgetModel {
    paragraphs: IParagraph[];
}

export interface IParagraph extends IRichContentItem {
    html: string;
}

export interface IRichContentItem {
    content: string;
}

export interface IPortalSubtopicRelatedPagesWidgetModel {
    faculties: string[];
    link: IExternalLinkWidgetModel;
}

export interface IPortalSubtopicContactWidgetModel {
    faculties: string[];
    link: IExternalLinkWidgetModel;
    contact: IContentBlockWidgetModel;
}

export interface IPortalSubtopicContactWidgetLabels {
    relatedPages: string;
    contact: string;
    emptyFacultySelection: string;
    facultySpecificContact: string;
    facultySpecificRelatedPages: string;
    selectFaculty: string;
    visit: string;
}

// classes
export class ExternalLinkWidgetModel implements IExternalLinkWidgetModel {
    description: string = '';
    url: string = '';
    isLoginModal: boolean = false;
    hasUrl: boolean = false;
}

export class ContentBlockWidgetModel implements IContentBlockWidgetModel {
    paragraphs: IParagraph[] = [];
}

export class Paragraph implements IParagraph {
    html: string = '';
    content: string = '';
}

export class PortalSubtopicRelatedPagesWidgetModel implements IPortalSubtopicRelatedPagesWidgetModel {
    faculties: string[] = [];
    link: ExternalLinkWidgetModel = new ExternalLinkWidgetModel();
}

export class PortalSubtopicContactWidgetModel implements IPortalSubtopicContactWidgetModel {
    faculties: string[] = [];
    link: ExternalLinkWidgetModel = new ExternalLinkWidgetModel();
    contact: ContentBlockWidgetModel = new ContentBlockWidgetModel();
}

export class PortalSubtopicAsideWidgetState {
    relatedPages: PortalSubtopicRelatedPagesWidgetModel[] = [];
    contactInformation: PortalSubtopicContactWidgetModel[] = [];
    selectedFaculty: string = '';
    associatedRelatedPages: PortalSubtopicRelatedPagesWidgetModel[] | null = null;
    associatedContactInfo: PortalSubtopicContactWidgetModel | null = null;
}
